import { identity } from "~/tools/identity";
import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

import { dashboardVariableLabelName } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";

export type FormState = ImpulseFormUnit<string, ReadonlyArray<string>>;

export const Processor: FormProcessor<FormState, undefined | string> = {
	fromSpec: (labelName) =>
		ImpulseFormUnit(labelName ?? "", {
			isInputDirty: isStringDirty,
			schema: dashboardVariableLabelName,
		}),

	toSpec: identity,
};
